import { Component, ViewChild, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { GrowerOrderService } from './../../../services/seed/growerOrder.service';
import { DashboardFilter } from '../../../models/DashboardFilter';
import { ConfigService } from './../../../services/infrastructure/config.service';
import { BroadcastService } from './../../../services/infrastructure/broadcaster.service';
import { ToastrService } from 'ngx-toastr';
import { SliderModelService } from './../../../services/infrastructure/sliderModel.service';
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { MasterConstants } from '../../constants/master-constants';
import { CommonService } from '../../../services/common/common.service';
import { Subscription } from 'rxjs';
import { LolLoggerService } from './../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-product-add',
  templateUrl: './product-add.component.html',
  styleUrls: ['./product-add.component.scss']
})
export class ProductAddComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();
  @ViewChild('productsTable', { read: MatSort}) itemSort: MatSort;
  accountId: number;
  public baseUrl;
  public productList: any;
  public selectedProductList = new Array();
  productDataSource: MatTableDataSource<any>;
  selectedValue: string;
  searchValue = '';
  searchTypeList: string[] = ['Product Name', 'Marketing Brand', 'Seed Size', 'Package Size', 'Technology', 'Treatment', 'Item Number', 'Maturity', 'Product Line'];
  searchTypeListMobile: string[] = ['Product Name', 'Marketing Brand', 'Seed Size', 'Package Size'];
  displayedColumns: string[] = ['SeedAvailability', 'NetBEU', 'DealerBucket', 'Product Name', 'Pack Size', 'Seed Size', 'Technology', 'Treatment', 'Maturity', 'Product Line'];
  public headerYear: any;
  public headerCompany = MasterConstants.US_COMPANYCODE;
  itemList = new Array();
  filterValueList = new Array();
  isTextBoxEmpty = true;
  isAddProductClick = false;
  isProductNotAdded = true;
  previousSelectedValue: string;
  // productMasterList: any = [];
  marketingMasterList: any = [];
  seedsizeMasterList: any = [];
  packagesizeMasterList: any = [];
  technologyMasterList: any = [];
  treatmentMasterList: any = [];
  maturityMasterList: any = [];
  productLineMasterList: any = [];
  itemNumberList: any = [];
  public partialSearchValue = '';
  productFilters: any;
  page: string;
  selectedGrowerGMK = 0;

  // for selected Person
  public selected: string;
  // for product availability Checkbox
  public enable: boolean;
  // for related dealer only checkbox
  public enableDealerCheckBox: boolean;

  constructor(
    private growerOrderService: GrowerOrderService,
    public broadcastService: BroadcastService,
    public configService: ConfigService,
    private toastrService: ToastrService,
    private sliderModelService: SliderModelService,
    private loaderService: LoaderService,
    private commonService: CommonService,
    private localStorageService: LocalStorageService) {
    this.sliderModelService.initializeProductChangeValue.subscribe(x => {
      this.page = x.page;
    });
  }

  ngOnInit() {
    this.bindDataSource([]);

    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.selectedValue = this.searchTypeList[0];
    this.previousSelectedValue = this.searchTypeList[0];
    this.selectedValue = this.searchTypeListMobile[0];
    this.previousSelectedValue = this.searchTypeListMobile[0];

    this.subscription.push(this.sliderModelService.initializeCompValue.subscribe(x => {
      this.accountId = +x;
    }));

    this.subscription.push(this.sliderModelService.selectedPsn.subscribe(y => {
      this.selected = y;
    }));

    this.subscription.push(this.commonService.seedOrderGrowerGMK.subscribe(growerGMK => {
      this.selectedGrowerGMK = +growerGMK || 0;
      if (this.productFilters) {
        this.productFilters.GrowerGMK = this.selectedGrowerGMK > 0 ? this.selectedGrowerGMK : null;
      }
    }));

    this.subscription.push(this.growerOrderService.SelectedGrowerObj.subscribe((grower: any) => {
      if (grower && +grower.gmk > 0) {
        this.selectedGrowerGMK = +grower.gmk;
        if (this.productFilters) {
          this.productFilters.GrowerGMK = this.selectedGrowerGMK;
        }
      }
    }));

    this.subscription.push(this.sliderModelService.sliderCloseRqt.subscribe(x => {
    }));

    if (this.selected === 'Dealer') {
      this.enable = true;
    }

    // load master data
    this.loadMasterData();
    this.resetProductFilter();    
  }

  public bindDataSource(data: any[]) {
    this.productDataSource = new MatTableDataSource(data);
    if (this.itemSort) {
      this.productDataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'SeedAvailability':
            return parseFloat(item.seedAvailability);
          case 'NetBEU':
            return parseFloat(item.netBEU);
          case 'DealerBucket':
            return parseFloat(item.myDealerBucket);
          default:
            return item[property];
        }
      };
      this.productDataSource.sort = this.itemSort;
    }
  }

  getProducts() {
    const growerGMK = this.selectedGrowerGMK > 0 ? this.selectedGrowerGMK : null;
    this.productFilters.ScreenName = 'grower';
    if (this.selected === 'Dealer' && this.enable === true) {
      this.productFilters.IsAvailabilityChecked = true;
      this.productFilters.ScreenName = 'dealer';
    }
    this.productFilters.CompanyCode = this.headerCompany;
    this.productFilters.CropYear = this.headerYear;
    this.productFilters.AccountNumber = this.accountId;
    this.productFilters.GrowerGMK = growerGMK;
    if (!this.validateProductFilter(this.productFilters)) {
      this.toastrService.error('Value must greater than equal to 2 characters.');
      return true;
    }
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.growerOrderService.getProductAvailability(this.productFilters).subscribe((result: any) => {
      if (result && result.status) {
        this.productList = result.resultData;
        this.productList.forEach(product => {
          product.ProductName = (product.brand != null ? product.brand : '') + (product.marketingBrand != null ? (' - ' + product.marketingBrand) : '');
          product.productNameFilter = (product.brand != null ? product.brand : '');
          product.IsProductSelected = (this.itemList.indexOf(product.itemNumber) != -1) ? true : false;
          product.PrimaryQuantity = 0;
          product.Quantity = 0;
          product.DesiredDeliveryDate = new Date();
          product.CustomerPO = '';
        });        
      }
      else {
        if (result) {
          this.toastrService.info(result.message);
          this.productList = [];          
        }
        else {
          this.toastrService.error('No Record Found. Please Change the Search Criteria and Search Again.');
          this.productList = [];
        }
      }

      this.bindDataSource(this.productList);

      // this.productPaginator.firstPage();
      // this.productDataSource.paginator = this.productPaginator;
      this.loaderService.setLoaderStatus(false);
    }, (error) => {
      this.productList = [];
      this.bindDataSource([]);
      // this.productDataSource.paginator = this.productPaginator;
      this.toastrService.error('No Record Found. Please Change the Search Criteria and Search Again.');
      this.loaderService.setLoaderStatus(false);
      LolLoggerService.error(error);
    }));
  }

  public getProductFilters(productFilter) {
    const growerGMK = this.selectedGrowerGMK > 0 ? this.selectedGrowerGMK : null;
    this.productFilters.CompanyCode = this.headerCompany;
    this.productFilters.CropYear = this.headerYear;
    this.productFilters.AccountNumber = this.accountId;
    this.productFilters.GrowerGMK = growerGMK;
    return productFilter;
  }

  // to validate product filter
  public validateProductFilter(productFilter) {
    let isValid = false;

    // To Validate Brand
    if (productFilter.Brand !== null && productFilter.Brand !== '' && productFilter.Brand.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate MarketingBrand
    if (productFilter.MarketingBrandList != null && productFilter.MarketingBrandList.length > 0) {
      isValid = true;
    }

    // To Validate SeedSize
    if (productFilter.SeedSizeList != null && productFilter.SeedSizeList.length > 0) {
      isValid = true;
    }

    // To Validate PackageSize
    if (productFilter.PackageSizeList != null && productFilter.PackageSizeList.length > 0) {
      isValid = true;
    }

    // To Validate Technology
    if (productFilter.TechnologyList != null && productFilter.TechnologyList !== '' && productFilter.TechnologyList.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate Treatment
    if (productFilter.TreatmentList != null && productFilter.TreatmentList.length > 0) {
      isValid = true;
    }

    // To Item Number
    if (productFilter.ItemNoList != null && productFilter.ItemNoList.length > 0) {
      isValid = true;
    }

    // To Validate Maturity Min & Max
    if (productFilter.MaturityMin != null && productFilter.MaturityMax != null) {
      isValid = true;
    }
    if (this.selectedValue == 'Maturity' && (productFilter.MaturityMin != null && productFilter.MaturityMax == null)
      &&
      (productFilter.MaturityMin != null && productFilter.MaturityMax == null)) {
      isValid = false;
    }

    // To Validate ProductLine
    if (productFilter.ProductLineList != null && productFilter.ProductLineList.length > 0) {
      isValid = true;
    }
    if (productFilter.Brand == null
      && (productFilter.MarketingBrandList == null || productFilter.MarketingBrandList.length <= 0)
      && (productFilter.SeedSizeList == null || productFilter.SeedSizeList.length <= 0)
      && (productFilter.PackageSizeList == null || productFilter.PackageSizeList.length <= 0)
      && (productFilter.TechnologyList == null)
      && (productFilter.TreatmentList == null || productFilter.TreatmentList.length <= 0)
      && (productFilter.ProductLineList == null || productFilter.ProductLineList.length <= 0)
      && (productFilter.ItemNoList == null || productFilter.ItemNoList.length <= 0)
      && (productFilter.MaturityMin == null)
      && (productFilter.MaturityMax == null)
    ) {
      isValid = false;
    }
    return isValid;
  }

  public keepRecords(item) {
    if (item.isProductDeactivated == false
      || (item.deactivationType == null
        || ((item.deactivationType.trim().toLowerCase() == 'full' || item.deactivationType.trim().toLowerCase() == 'partial') && this.page == 'growerOrder'))) {
      item.IsProductSelected = !item.IsProductSelected;
      const itemNumber = item.itemNumber;
      if (item.IsProductSelected) {
        this.itemList.push(itemNumber);
        var item = this.productList.filter(i => i.itemNumber == itemNumber);
        this.selectedProductList.push(item[0]);
      }
      else {
        const index = this.itemList.indexOf(itemNumber);    // <-- Not supported in <IE9
        if (index !== -1) {
          this.itemList.splice(index, 1);
        }
        this.selectedProductList = this.selectedProductList.filter(i => i.itemNumber != itemNumber);
      }
      if (this.selectedProductList.length > 0) {
        this.isProductNotAdded = false;
      }
      else {
        this.isProductNotAdded = true;
      }
    }
  }

  public AddProducts() {
    if (this.selectedProductList.length > 0) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productCount: this.selectedProductList.length });
      this.toastrService.info('Product Added');
    }
    this.isAddProductClick = true;
    const data = Object.assign({}, this);
    this.sliderModelService.setData<ProductAddComponent>(data);
    this.sliderModelService.close();
  }

  public keepFilter() {
    if (this.filterValueList) {
      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.Brand && this.productFilters.Brand != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.Brand);
        }
        if (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) {
          let strMB = '';
          this.productFilters.MarketingBrandList.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Marketing Brand : ' + strMB.substr(0, strMB.length - 2));
        }
        if (this.productFilters.SeedSizeList && this.productFilters.SeedSizeList.length > 0) {
          let strSS = '';
          this.productFilters.SeedSizeList.forEach(x => {
            strSS = strSS + x + ', ';
          });
          this.filterValueList.push('Seed Size : ' + strSS.substr(0, strSS.length - 2));
        }
        if (this.productFilters.PackageSizeList && this.productFilters.PackageSizeList.length > 0) {
          let strPS = '';
          this.productFilters.PackageSizeList.forEach(x => {
            strPS = strPS + x + ', ';
          });
          this.filterValueList.push('Package Size : ' + strPS.substr(0, strPS.length - 2));
        }
        if (this.productFilters.TechnologyList && this.productFilters.TechnologyList != '') {
          this.filterValueList.push('Technology : ' + this.productFilters.TechnologyList);
        }
        if (this.productFilters.TreatmentList && this.productFilters.TreatmentList.length > 0) {
          let strTreat = '';
          this.productFilters.TreatmentList.forEach(x => {
            strTreat = strTreat + x + ', ';
          });
          this.filterValueList.push('Treatment : ' + strTreat.substr(0, strTreat.length - 2));
        }
        if (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0) {
          let strPL = '';
          this.productFilters.ProductLineList.forEach(x => {
            strPL = strPL + x + ', ';
          });
          this.filterValueList.push('Product Line : ' + strPL.substr(0, strPL.length - 2));
        }
        if (this.productFilters.ItemNoList && this.productFilters.ItemNoList.length > 0) {
          let strINO = '';
          this.productFilters.ItemNoList.forEach(x => {
            strINO = strINO + x + ', ';
          });
          this.filterValueList.push('Item Number : ' + strINO.substr(0, strINO.length - 2));
        }

        if (this.productFilters.MaturityMin != null && this.productFilters.MaturityMax != null) {
          this.filterValueList.push('Maturity : (' + this.productFilters.MaturityMin + ') - (' + this.productFilters.MaturityMax + ')');
        }
      }

      // this.filterValueList.push(this.previousSelectedValue + " : " + this.searchValue);
    }
    if (this.productFilters && (this.productFilters.Brand != null && this.productFilters.Brand !== '') ||
      (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) ||
      (this.productFilters.SeedSizeList && this.productFilters.SeedSizeList.length > 0) ||
      (this.productFilters.PackageSizeList && this.productFilters.PackageSizeList.length > 0) ||
      (this.productFilters.TechnologyList != null && this.productFilters.TechnologyList !== '') ||
      (this.productFilters.TreatmentList && this.productFilters.TreatmentList.length > 0) ||
      (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0) ||
      (this.productFilters.MaturityMin != null) ||
      (this.productFilters.MaturityMax != null) ||
      (this.productFilters.ItemNoList && this.productFilters.ItemNoList.length > 0)) {
      this.productFilters = this.getProductFilters(this.productFilters);
    }
    this.enableDisableSearch();

    this.previousSelectedValue = this.selectedValue;
    this.searchValue = '';
    this.partialSearchValue = '';
  }

  enableDisableSearch() {
    if (this.validateProductFilter(this.productFilters)) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  validateProductSearch() {
    // To Validate Brand
    if (this.productFilters.Brand !== null && this.productFilters.Brand !== '' && this.productFilters.Brand.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  validateTechnologySearch() {
    // To Validate Brand
    if (this.productFilters.TechnologyList !== null && this.productFilters.TechnologyList !== '' && this.productFilters.TechnologyList.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  public clearAllFilter() {
    this.filterValueList = new Array();
    this.searchValue = '';
    this.productList = new Array();
    this.isTextBoxEmpty = true;
    this.resetProductFilter();
    this.productDataSource = new MatTableDataSource([]);
    // this.productPaginator.firstPage();
    // this.productDataSource.paginator = this.productPaginator;
  }

  public clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    this.searchValue = '';
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeProductFilter(filterValue);

      if (this.filterValueList.length < 1) {
        this.productList = new Array();
        this.productDataSource = new MatTableDataSource([]);
        // this.productPaginator.firstPage();
        // this.productDataSource.paginator = this.productPaginator;
      }
      this.enableDisableSearch();
    }
  }

  // To remove clear search filter
  public removeProductFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Product Name':
        this.productFilters.Brand = null;
        break;
      case 'Marketing Brand':
        this.productFilters.MarketingBrandList = [];
        break;
      case 'Seed Size':
        this.productFilters.SeedSizeList = [];
        break;
      case 'Package Size':
        this.productFilters.PackageSizeList = [];
        break;
      case 'Technology':
        this.productFilters.TechnologyList = null;
        break;
      case 'Treatment':
        this.productFilters.TreatmentList = [];
        break;
      case 'Maturity':
        this.productFilters.MaturityMin = null;
        this.productFilters.MaturityMax = null;
        break;
      case 'Product Line':
        this.productFilters.ProductLineList = [];
        break;
      case 'Item Number':
        this.productFilters.ItemNoList = [];
        break;
      default:
        break;
    }
  }

  public loadMasterData() {
    // get Item Number List
    this.subscription.push(this.commonService.getItemNumbers().subscribe((result: any) => {
      this.itemNumberList = result;
    }));

    // MarketingBrand master data
    if (this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST)) {
      this.marketingMasterList = JSON.parse(this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST));
    }

    // SeedSize master data
    if (this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST)) {
      this.seedsizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST)) {
      this.packagesizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST));
    }

    // Technology master data
    if (this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST)) {
      this.technologyMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST));
    }

    // Treatment master data
    if (this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST)) {
      this.treatmentMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST));
    }

    // Maturity master data
    if (this.localStorageService.get(MasterConstants.MATURITY_LIST)) {
      this.maturityMasterList = JSON.parse(this.localStorageService.get(MasterConstants.MATURITY_LIST));
    }

    // ProductLine master data
    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST)) {
      this.productLineMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST));
    }
  }

  // Table sorting
  sortData(sort: Sort) {
    sort.direction = 'desc';
    const data = this.productDataSource.data.slice();
    if (!sort.active) {
      return;
    } 

    this.productDataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      return this.compare(a[sort.active], b[sort.active], isAsc);
    });
  }

  public compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  // search in master search area
  public filterSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.value.toLocaleLowerCase().indexOf(term) > -1;
  }

  public partialSearch(searchValue: string) {
    if (searchValue != undefined) {
      this.partialSearchValue = searchValue;
    }
  }

  public checkAvailability(isAvailabilityChecked: boolean) {
    this.productFilters.IsAvailabilityChecked = isAvailabilityChecked;
  }

  public checkDealerOrderAvailability(isAvailabilityChecked: boolean) {
    this.productFilters.IsRelatedtoDealerItemsOnly = isAvailabilityChecked;
  }

  public resetProductFilter() {
    this.productFilters = {
      'CompanyCode': this.headerCompany,
      'CropYear': this.headerYear,
      'AccountNumber': this.accountId,
      'GrowerGMK': this.selectedGrowerGMK > 0 ? this.selectedGrowerGMK : null,
      'IsAvailabilityChecked': false,
      'IsRelatedtoDealerItemsOnly': false,
      'Brand': null,
      'MarketingBrandList': [],
      'SeedSizeList': [],
      'PackageSizeList': [],
      'TechnologyList': null,
      'TreatmentList': [],
      'ProductLineList': [],
      'MaturityMin': null,
      'MaturityMax': null,
      'ItemNoList': []
    };
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
